// Картка #578: бек рахує дати доставки опівночі за Києвом і віддає unix-час.
// moment.unix(...).format() форматує в поясі браузера - у клієнта в Польщі
// київська північ це 23:00 попереднього дня, і дата з'їжджала на день раніше.
// Форматуємо явно в київському поясі, як це робить бек (date('d.m.Y') при Europe/Kyiv).
// 'Europe/Kiev' - старе ім'я того ж поясу: його знають і браузери зі старою tzdata,
// де 'Europe/Kyiv' кидає RangeError.
const kyivDateFormat = new Intl.DateTimeFormat('uk-UA', {
  timeZone: 'Europe/Kiev',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});

/** unix-час (секунди) -> 'DD.MM.YYYY' за київським часом */
export function formatUnixDateKyiv(unix: number | string): string {
  const parts = kyivDateFormat.formatToParts(new Date(Number(unix) * 1000));
  const part = (type: string) => parts.find(p => p.type === type)?.value || '';

  return `${part('day')}.${part('month')}.${part('year')}`;
}
